import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'
import './pixelRuntime'

// Next.js <Script onReady> fires before an inline body executes, so we can't
// rely on it to signal that window.axon is defined. Mark ready from inside the
// snippet via window.__sfMarkVendorReady (installed by pixelRuntime).
export const AppLovinPixel: React.FC<{
    landingPage: ApiShopperLandingPage
}> = ({ landingPage }) => {
    if (!landingPage.integrations.applovinEventKey) return null

    return (
        <Script id="applovin-pixel" strategy="afterInteractive">
            {`
                !function(){
                    var COOKIE_HTTP="axwrt",COOKIE_ID="_axwrt",COOKIE_TS="_axwrt_ts",MAX_AGE_DAYS=365;
                    var UUID_V4=/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
                    function getCookie(name){var m=document.cookie.match(new RegExp("(?:^|; )"+name.replace(/([.$?*|{}()\\[\\]\\\\\\/+^])/g,"\\\\$1")+"=([^;]*)"));return m?decodeURIComponent(m[1]):null}
                    function setCookie(name,value,days){var expires=new Date(Date.now()+days*864e5).toUTCString();document.cookie=name+"="+encodeURIComponent(value)+"; expires="+expires+"; path=/"}
                    function isValidId(value){return value&&UUID_V4.test(value)?value:null}
                    function readSetTs(id){var raw=getCookie(COOKIE_TS);if(!raw||!id)return null;var i=raw.lastIndexOf(".");if(i<0||raw.slice(0,i)!==id)return null;var n=parseInt(raw.slice(i+1),10);return n>0?n:null}

                    var http=isValidId(getCookie(COOKIE_HTTP));
                    var script=isValidId(getCookie(COOKIE_ID));
                    var id=http||script;
                    var setTs=readSetTs(id);

                    if(!id){
                        var shopifyClientId=getCookie("_shopify_y");
                        if(!shopifyClientId)return;
                        id=shopifyClientId;
                    }

                    if(!http&&!script)setCookie(COOKIE_ID,id,MAX_AGE_DAYS);
                    if(!setTs)setCookie(COOKIE_TS,id+"."+Date.now(),MAX_AGE_DAYS);
                }();

                var AXON_EVENT_KEY="${landingPage.integrations.applovinEventKey}";
                !function(e,r){var t=["https://s.axon.ai/pixel.js","https://res4.applovin.com/p/l/loader.iife.js"];if(!e.axon){var a=e.axon=function(){a.performOperation?a.performOperation.apply(a,arguments):a.operationQueue.push(arguments)};a.operationQueue=[],a.ts=Date.now(),a.eventKey=AXON_EVENT_KEY;for(var n=r.getElementsByTagName("script")[0],o=0;o<t.length;o++){var i=r.createElement("script");i.async=!0,i.src=t[o],n.parentNode.insertBefore(i,n)}}}(window,document);
                axon("init");
                window.__sfMarkVendorReady && window.__sfMarkVendorReady("axon");
            `}
        </Script>
    )
}
